// PGCET MCA Mock 6 — General Awareness (questions 71–90)
const pgcetmcaGeneralAwareness = [
  {
    id: 71,
    question: "The Fundamental Duties were added to the Constitution of India by the",
    options: ["A. 44th Amendment Act, 1978", "B. 42nd Amendment Act, 1976", "C. 52nd Amendment Act, 1985", "D. 86th Amendment Act, 2002"],
    answer: "B"
  },
  {
    id: 72,
    question: "The Right to Constitutional Remedies, described by Dr. B.R. Ambedkar as the 'heart and soul' of the Constitution, is contained in",
    options: ["A. Article 14", "B. Article 19", "C. Article 32", "D. Article 51A"],
    answer: "C"
  },
  {
    id: 73,
    question: "Which Article of the Constitution of India abolishes untouchability?",
    options: ["A. Article 15", "B. Article 16", "C. Article 18", "D. Article 17"],
    answer: "D"
  },
  {
    id: 74,
    question: "A Money Bill is defined in which Article of the Constitution of India?",
    options: ["A. Article 110", "B. Article 112", "C. Article 123", "D. Article 352"],
    answer: "A"
  },
  {
    id: 75,
    question: "The idea of the Directive Principles of State Policy in the Indian Constitution was borrowed from the Constitution of",
    options: ["A. USA", "B. UK", "C. Ireland", "D. Canada"],
    answer: "C"
  },
  {
    id: 76,
    question: "The minimum age required to become a member of the Lok Sabha is",
    options: ["A. 21 years", "B. 25 years", "C. 30 years", "D. 35 years"],
    answer: "B"
  },
  {
    id: 77,
    question: "President's Rule in a state is imposed under",
    options: ["A. Article 352", "B. Article 360", "C. Article 368", "D. Article 356"],
    answer: "D"
  },
  {
    id: 78,
    question: "Who was the Chairman of the Drafting Committee of the Constituent Assembly of India?",
    options: ["A. Dr. B.R. Ambedkar", "B. Dr. Rajendra Prasad", "C. Jawaharlal Nehru", "D. Sardar Vallabhbhai Patel"],
    answer: "A"
  },
  {
    id: 79,
    question: "The longest river of peninsular India is the",
    options: ["A. Krishna", "B. Kaveri", "C. Godavari", "D. Mahanadi"],
    answer: "C"
  },
  {
    id: 80,
    question: "The Palk Strait separates",
    options: ["A. India and Myanmar", "B. India and Sri Lanka", "C. Andaman and Nicobar Islands", "D. India and the Maldives"],
    answer: "B"
  },
  {
    id: 81,
    question: "The Standard Meridian of India (on which Indian Standard Time is based) is",
    options: ["A. 82.5° E", "B. 77.5° E", "C. 88.5° E", "D. 80° E"],
    answer: "A"
  },
  {
    id: 82,
    question: "Black soil (regur) of the Deccan plateau is best suited for the cultivation of",
    options: ["A. Tea", "B. Rice", "C. Jute", "D. Cotton"],
    answer: "D"
  },
  {
    id: 83,
    question: "Which is the largest state of India by area?",
    options: ["A. Madhya Pradesh", "B. Maharashtra", "C. Rajasthan", "D. Uttar Pradesh"],
    answer: "C"
  },
  {
    id: 84,
    question: "Which is the largest ocean in the world?",
    options: ["A. Atlantic Ocean", "B. Indian Ocean", "C. Arctic Ocean", "D. Pacific Ocean"],
    answer: "D"
  },
  {
    id: 85,
    question: "Which gas is the most abundant in the Earth's atmosphere?",
    options: ["A. Oxygen", "B. Nitrogen", "C. Argon", "D. Carbon dioxide"],
    answer: "B"
  },
  {
    id: 86,
    question: "Which cell organelle is known as the 'powerhouse of the cell'?",
    options: ["A. Ribosome", "B. Nucleus", "C. Mitochondria", "D. Golgi body"],
    answer: "C"
  },
  {
    id: 87,
    question: "The pH value of pure water at 25 °C is",
    options: ["A. 7", "B. 0", "C. 14", "D. 1"],
    answer: "A"
  },
  {
    id: 88,
    question: "The speed of light in vacuum is approximately",
    options: ["A. 3 × 10⁶ m/s", "B. 3 × 10¹⁰ m/s", "C. 3 × 10⁵ m/s", "D. 3 × 10⁸ m/s"],
    answer: "D"
  },
  {
    id: 89,
    question: "Which is the hardest naturally occurring substance?",
    options: ["A. Diamond", "B. Graphite", "C. Quartz", "D. Iron"],
    answer: "A"
  },
  {
    id: 90,
    question: "Which instrument is used to measure atmospheric pressure?",
    options: ["A. Hygrometer", "B. Barometer", "C. Ammeter", "D. Thermometer"],
    answer: "B"
  }
];

export default pgcetmcaGeneralAwareness;
